import { PaymentRequestsListQuerystring } from "../components/payment-request/List/types"
import { AllCompaniesQuerystring } from "../../../backend/src/routes/company/all.types"
import { AllHistoryLogsQuerystring } from "../../../backend/src/routes/history-log/all.types"
import { AllSuppliersQuerystring } from "../../../backend/src/routes/supplier/all.types"
import { AllUsersQuerystring } from "../../../backend/src/routes/user/all.types"
import { QueryStringMapper } from "../utils/queryStringSerialization"
import { InvoicesListQuerystring } from "../components/invoice/list/types"
import { ArchiveListQuerystring } from "../components/archive/List/types"

export type IPagedListQuery = {
    page?: number
    pageSize?: number
}

export const PagedListSerializationMapper: QueryStringMapper<IPagedListQuery> = {
    page: {
        queryStringKey: "page",
        dataType: "number",
    },
    pageSize: {
        queryStringKey: "pageSize",
        dataType: "number",
    },
}

export const companyFilterSerializationMapper: QueryStringMapper<AllCompaniesQuerystring> = {
    name: {
        queryStringKey: "name",
        dataType: "string",
    },
    email: {
        queryStringKey: "email",
        dataType: "string",
    },
    ic: {
        queryStringKey: "ic",
        dataType: "number",
    },
    dic: {
        queryStringKey: "dic",
        dataType: "string",
    },
    sortField: {
        queryStringKey: "sortBy",
        dataType: "string",
    },
    sortDesc: {
        queryStringKey: "sortDesc",
        dataType: "boolean",
    },
}

export const historyLogsFilterSerializationMapper: QueryStringMapper<AllHistoryLogsQuerystring> = {
    userId: {
        queryStringKey: "userId",
        dataType: "number",
    },
    sortField: {
        queryStringKey: "sortBy",
        dataType: "string",
    },
    sortDesc: {
        queryStringKey: "sortDesc",
        dataType: "boolean",
    },
}

export const usersFilterSerializationMapper: QueryStringMapper<AllUsersQuerystring> = {
    name: {
        queryStringKey: "name",
        dataType: "string",
    },
    email: {
        queryStringKey: "email",
        dataType: "string",
    },
    companyId: {
        queryStringKey: "company",
        dataType: "number",
    },
    sortField: {
        queryStringKey: "sortBy",
        dataType: "string",
    },
    sortDesc: {
        queryStringKey: "sortDesc",
        dataType: "boolean",
    },
}

export const supplierFilterSerializationMapper: QueryStringMapper<AllSuppliersQuerystring> = {
    name: {
        queryStringKey: "name",
        dataType: "string",
    },
    ic: {
        queryStringKey: "ic",
        dataType: "number",
    },
    dic: {
        queryStringKey: "dic",
        dataType: "string",
    },
    sortField: {
        queryStringKey: "sortBy",
        dataType: "string",
    },
    sortDesc: {
        queryStringKey: "sortDesc",
        dataType: "boolean",
    },
}

export const paymentRequestsFilterSerializationMapper: QueryStringMapper<PaymentRequestsListQuerystring> = {
    ...PagedListSerializationMapper,
    type: {
        queryStringKey: "type",
        dataType: "string",
    },
    description: {
        queryStringKey: "desc",
        dataType: "string",
    },
    amount: {
        queryStringKey: "amount",
        dataType: "number",
    },
    amountOp: {
        queryStringKey: "amountOp",
        dataType: "string",
    },
    id: {
        queryStringKey: "id",
        dataType: "number",
    },
    createdBy: {
        queryStringKey: "createdBy",
        dataType: "number",
    },
    approverId: {
        queryStringKey: "approverId",
        dataType: "number",
    },
    approvalDate: {
        queryStringKey: "approvalDate",
        dataType: "dayjs",
    },
    companyId: {
        queryStringKey: "company",
        dataType: "number",
    },
    supplierId: {
        queryStringKey: "supplier",
        dataType: "number",
    },
    statuses: {
        queryStringKey: "statuses",
        dataType: "number[]",
    },
    categories: {
        queryStringKey: "categories",
        dataType: "number[]",
    },
    sortField: {
        queryStringKey: "sortBy",
        dataType: "string",
    },
    sortDesc: {
        queryStringKey: "sortDesc",
        dataType: "boolean",
    },
    validityStartDate: {
        queryStringKey: "validityStartDate",
        dataType: "dayjs",
    },
    validityEndDate: {
        queryStringKey: "validityEndDate",
        dataType: "dayjs",
    },
}

export const invoicesFilterSerializationMapper: QueryStringMapper<InvoicesListQuerystring> = {
    ...PagedListSerializationMapper,
    id: {
        queryStringKey: "id",
        dataType: "number",
    },
    authorId: {
        queryStringKey: "author",
        dataType: "number",
    },
    type: {
        queryStringKey: "type",
        dataType: "string",
    },
    amount: {
        queryStringKey: "amount",
        dataType: "number",
    },
    amountOp: {
        queryStringKey: "amountOp",
        dataType: "string",
    },
    paymentRequestId: {
        queryStringKey: "paymentRequest",
        dataType: "number",
    },
    companyId: {
        queryStringKey: "company",
        dataType: "number",
    },
    supplierId: {
        queryStringKey: "supplier",
        dataType: "number",
    },
    filename: {
        queryStringKey: "filename",
        dataType: "string",
    },
    externalId: {
        queryStringKey: "externalId",
        dataType: "string",
    },
    statuses: {
        queryStringKey: "statuses",
        dataType: "number[]",
    },
    date: {
        queryStringKey: "date",
        dataType: "dayjs",
    },
    dateOp: {
        queryStringKey: "dateOp",
        dataType: "string",
    },
    dateMin: {
        queryStringKey: "dateMin",
        dataType: "dayjs",
    },
    dateMax: {
        queryStringKey: "dateMax",
        dataType: "dayjs",
    },
    hasDuplicate: {
        queryStringKey: "hasDuplicate",
        dataType: "boolean",
    },
    sortField: {
        queryStringKey: "sortBy",
        dataType: "string",
    },
    sortDesc: {
        queryStringKey: "sortDesc",
        dataType: "boolean",
    },
}

export const archiveFilterSerializationMapper: QueryStringMapper<ArchiveListQuerystring> = {
    ...PagedListSerializationMapper,
    searchText: {
        queryStringKey: "searchText",
        dataType: "string",
    },
    companyId: {
        queryStringKey: "company",
        dataType: "number",
    },
    filename: {
        queryStringKey: "filename",
        dataType: "string",
    },
    externalId: {
        queryStringKey: "externalId",
        dataType: "string",
    },
    createdBy: {
        queryStringKey: "createdBy",
        dataType: "number",
    },
    categoryId: {
        queryStringKey: "category",
        dataType: "number",
    },
    type: {
        queryStringKey: "type",
        dataType: "number",
    },
    date: {
        queryStringKey: "date",
        dataType: "dayjs",
    },
    dateOp: {
        queryStringKey: "dateOp",
        dataType: "string",
    },
    sortField: {
        queryStringKey: "sortBy",
        dataType: "string",
    },
    sortDesc: {
        queryStringKey: "sortDesc",
        dataType: "boolean",
    },
}
